import React from 'react';
export const Newsletter = () => {
  return <section className="py-16 md:py-24 bg-scarlet text-white" data-id="element-119">
      <div className="container mx-auto px-4" data-id="element-120">
        <div className="max-w-2xl mx-auto text-center" data-id="element-121">
          <h2 className="font-heading text-3xl md:text-4xl mb-4 uppercase tracking-wide" data-id="element-122">
            Get First Access to New Drops
          </h2>
          <p className="text-white/90 mb-8 text-lg" data-id="element-123">
            Join our newsletter for exclusive alerts on rare cards, new
            signings, and special promotions.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 w-full max-w-lg mx-auto" onSubmit={e => e.preventDefault()} data-id="element-124">
            <input type="email" placeholder="Enter your email address" className="flex-grow px-4 py-3 text-ink min-h-[56px] border-4 border-ink shadow-[4px_4px_0px_0px_#1A1A1A] focus:outline-none focus:translate-x-[2px] focus:translate-y-[2px] focus:shadow-[2px_2px_0px_0px_#1A1A1A] transition-all font-bold" required data-id="element-125" />
            <button type="submit" className="bg-ink text-white font-heading text-xl tracking-wider px-8 py-3 border-4 border-ink shadow-[4px_4px_0px_0px_#1A1A1A] hover:shadow-[2px_2px_0px_0px_#1A1A1A] hover:translate-x-[2px] hover:translate-y-[2px] transition-all min-h-[56px] flex items-center justify-center whitespace-nowrap" data-id="element-126">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>;
};